import { AbstractControl, FormGroupDirective, NgForm, ValidationErrors, ValidatorFn } from '@angular/forms';
import { ErrorStateMatcher } from '@angular/material/core';

export interface PasswordPolicyErrors {
  minLength?: true;
  lowercase?: true;
  uppercase?: true;
  numbers?: true;
  special?: true;
}

export class PasswordValidator {
  static policyValidator(control: AbstractControl): ValidationErrors | null {
    const value: string = control.value as string;
    if (!value) return null;

    const errors: PasswordPolicyErrors = {};

    if (value.length < 8)
      errors.minLength = true;

    if ((value.match(/[a-z]/g) ?? []).length < 2)
      errors.lowercase = true;

    if ((value.match(/[A-Z]/g) ?? []).length < 2)
      errors.uppercase = true;

    if ((value.match(/\d/g) ?? []).length < 2)
      errors.numbers = true;

    if (!/["!@#$%^&*(){}:;<>,.?/+\-_=|'[\]\\]/.test(value))
      errors.special = true;

    const hasErrors = Object.keys(errors).length > 0;
    return hasErrors ? { passwordPolicy: errors } : null;
  }

  static changedValidator(currentPasswordField: string, newPasswordField: string): ValidatorFn {
    return (formGroup: AbstractControl): ValidationErrors | null => {
      const currentPassword = formGroup.get(currentPasswordField);
      const newPassword = formGroup.get(newPasswordField);

      if (!currentPassword || !newPassword || newPassword.value === '') return null;

      return currentPassword.value === newPassword.value ? { passwordUnchanged: true } : null;
    };
  }

  static matchValidator(passwordField: string, confirmPasswordField: string): ValidatorFn {
    return (formGroup: AbstractControl): ValidationErrors | null => {
      const password = formGroup.get(passwordField);
      const confirm = formGroup.get(confirmPasswordField);

      if (!password || !confirm || confirm.value === '') return null;

      return password.value === confirm.value ? null : { passwordMismatch: true };
    };
  }
}

export class PasswordUnchangedStateMatcher implements ErrorStateMatcher {
  isErrorState(control: AbstractControl | null, form: FormGroupDirective | NgForm | null): boolean {
    return control?.touched && (control?.invalid || form?.hasError('passwordUnchanged'));
  }
}

export class PasswordMismatchStateMatcher implements ErrorStateMatcher {
  isErrorState(control: AbstractControl | null, form: FormGroupDirective | NgForm | null): boolean {
    return control?.touched && (control?.invalid || form?.hasError('passwordMismatch'));
  }
}